import React, { PureComponent } from 'react';
import { string, func, shape, number } from 'prop-types';
import cn from 'classnames';

class StudentListRow extends PureComponent {
  render() {
    const {
      enrollment,
      firstName,
      lastName,
      onSelect,
      currentGradeInstance
    } = this.props;
    const currentYear = (new Date()).getFullYear();
    const instanceYear = currentGradeInstance.year;
    const isActive = currentYear === instanceYear;
    const className = cn(
      'student-row',
      { 'student-row-inactive': !isActive }
    );

    return (
      <div
        onClick={onSelect}
        className={className}
      >
        <span>{enrollment}</span>
        <span>{firstName}</span>
        <span>{lastName}</span>
        <span className="conditional-column">
          {currentGradeInstance.cycleName}
        </span>
        <span className="conditional-column">
          {currentGradeInstance.name}
          {!isActive && ` (${currentGradeInstance.year})`}
        </span>
      </div>
    );
  }
}

StudentListRow.propTypes = {
  firstName: string.isRequired,
  lastName: string.isRequired,
  onSelect: func.isRequired,
  currentGradeInstance: shape({
    cycleName: string,
    name: string,
    year: number
  }),
  enrollment: string
};

StudentListRow.defaultProps = {
  enrollment: 'N/A'
};

export default StudentListRow;



// WEBPACK FOOTER //
// ./src/components/student/StudentListRow.js